<template>
  <div>
    <div
      v-for="category in categoriesWithoutOptions"
      :key="category.title"
      class="mb-4"
    >
      <div
        v-for="service in category.services"
        :key="service.id"
        class="d-flex align-center ga-2"
      >
        <slot :service="service" />
      </div>
    </div>

    <SoExpansionPanels v-if="categoriesWithOptions.length > 0" class="mt-2">
      <SoExpansionPanel
        v-for="category in categoriesWithOptions"
        :key="category.title"
      >
        <template #title>{{ category.title }}</template>

        <div
          v-for="(service, index) in category.services"
          :key="service.id"
          class="mb-4"
          :class="{ 'mt-4': index === 0 }"
        >
          <slot :service="service" />
        </div>
      </SoExpansionPanel>
    </SoExpansionPanels>
  </div>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import SoExpansionPanels from "@/components/expansionPanels/SoExpansionPanels.vue"
  import SoExpansionPanel from "@/components/expansionPanels/SoExpansionPanel.vue"
  import { IPsrPriorityService } from "@/models/psr/psr.types"

  export interface PsrSoSupportiveServiceCategory {
    title: string
    services: Array<IPsrPriorityService>
  }

  export default defineComponent({
    components: {
      SoExpansionPanels,
      SoExpansionPanel,
    },
    props: {
      categories: {
        type: Array as PropType<Array<PsrSoSupportiveServiceCategory>>,
        required: true,
      },
    },
    computed: {
      categoriesWithOptions(): Array<PsrSoSupportiveServiceCategory> {
        return this.categories.filter(
          (category) => category.services.length > 1,
        )
      },
      categoriesWithoutOptions(): Array<PsrSoSupportiveServiceCategory> {
        return this.categories.filter(
          (category) => category.services.length <= 1,
        )
      },
    },
  })
</script>

<style scoped>
  :deep(.so-expansion-panel) {
    margin-bottom: 16px;
  }
  :deep(.so-expansion-panel:last-child) {
    margin-bottom: 0;
  }
  /* Align flush left with the standalone checkboxes above (which have no
     left padding of their own), but give the right side more room than
     Vuetify's default 8px — the expand chevron sits at the far right edge
     of the title and was rendering right up against the modal's scrollbar. */
  :deep(.v-expansion-panel-title) {
    padding-left: 0 !important;
    padding-right: 24px !important;
  }
  :deep(.v-expansion-panel-text) {
    padding-left: 0 !important;
    padding-right: 24px !important;
  }
</style>
